import {RoutesData} from './routing.config';

// Re-export RoutesData for backward compatibility
const appRoutes = RoutesData;

export default appRoutes;
